import { ModalLoading } from 'components/ModalLoading';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimExportWorkOrderChangeQuery } from 'gql/graphql';
import { downloadURI } from 'utils/downloadDataURI';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimExportWorkOrderChangeGql } from './exportWorkOrderChangeBimQueries';

interface IExportWorkOrderChangeBim {
    workOrderChangeId: number;
    onClose: () => void;
}

const requestId = 'bimExportWorkOrderChange';

export const ExportWorkOrderChangeBim = (props: IExportWorkOrderChangeBim) => {
    const { onClose, workOrderChangeId } = props;

    const dispatch = useDispatch();

    const [resetData] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({
            workOrderChangeId,
        }),
        [workOrderChangeId],
    );

    const onSuccess = useCallback(
        (res: TActionCommonInterface<BimExportWorkOrderChangeQuery>) => {
            const { name, dataUrl } = res?.payload?.bimExportWorkOrderChange?.data ?? {};

            if (dataUrl && name) {
                downloadURI(dataUrl, name);
            }

            onClose();
            resetData(undefined);
        },
        [onClose, resetData],
    );

    const [, , , , , abortRequest] = useRequest({
        requestId,
        query: bimExportWorkOrderChangeGql,
        withEffect: !!workOrderChangeId,
        variables,
        dependenciesUpdater: onSuccess,
    });

    const onLocalClose = useCallback(() => {
        dispatch(abortRequest());
        onClose();
    }, [abortRequest, dispatch, onClose]);

    return <ModalLoading title="Выгрузка Изм к НЗ" onClose={onLocalClose} />;
};

ExportWorkOrderChangeBim.displayName = 'ExportWorkOrderChangeBim';
